import Parseable from '@/misc/Parseable';
import moment from 'moment';
import i18n from '@/i18n';

export default class TokenInformation extends Parseable {

    /**
     * Determines if token can be used
     */
    public isApplicable!: boolean;
    /**
     * Determines if the current user was applied already
     */
    public isUsersToken!: boolean;
    /**
     * Determines the point on which the token is expired and connet be used. null means no restriction.
     */
    public expiration!: string | null;
    /**
     * Determines the point until the token needs to be redeemed. null means no restriction.
     */
    public applicableUntil!: string | null;

    /**
     * Returns the validation error message based on the class state
     */
    public get validationMessage(): { key: string, data: any } {
        // ATTENTION both cases uses the same error message (currently it is not possible to distinguish between two these cases)
        if (this.expiration) {
            if (moment(this.expiration).isBefore(moment())) {
                const expirationFormat = moment(this.expiration).format(i18n.t('FORMATS.DATE_TIME').toString());
                return { key: 'CODE.TOKEN.EXPIRATION_ERROR_MESSAGE', data: { expirationFormat } };
            }
        }
        // ATTENTION both cases uses the same error message (currently it is not possible to distinguish between two these cases)
        if (this.applicableUntil) {
            if (moment(this.applicableUntil).isBefore(moment())) {
                const applicableUntilFormat = moment(this.applicableUntil).format(i18n.t('FORMATS.DATE_TIME').toString());
                return { key: 'CODE.TOKEN.EXPIRATION_ERROR_MESSAGE', data: { applicableUntilFormat } };
            }
        }
        // general error, wrong token input or all tokens are in use.
        return { key: 'CODE.TOKEN.GENERAL_TOKEN_ERROR_MESSAGE', data: null };
    }

    public static parseFromObject(object: any): TokenInformation {
        const tokenInformation = new TokenInformation();

        object.isApplicable = object.is_applicable;
        delete object.is_applicable;
        object.isUsersToken = object.is_users_token;
        delete object.is_users_token;
        object.applicableUntil = object.applicable_until;
        delete object.applicable_until;

        Object.assign(tokenInformation, object);
        return tokenInformation;
    }

    public parseToObject(): Partial<TokenInformation> {
        return { ...this };
    }
}
